import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import getDataById from "../../../hooks/admin/getDataById";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import ImageUploading from "react-images-uploading";
import {
  Button,
  Form,
  Input,
  Typography,
  Card,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const EditLanguage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("admin"));

  const onChange = (imageList) => setImages(imageList);

  useEffect(() => {
    setLoading(true);
    const getLanguage = async () => {
      const res = await getDataById("admin/getbyidlanguage", id);
      if (res.status_code === 200) {
        const { language_short_name, language_full_name, image } = res.data;

        form.setFieldsValue({
          language_short_name,
          language_full_name,
        });

        // ✅ Preload image if it exists
        if (image) {
          setImages([
            {
              data_url: image,
              file: null,
            },
          ]);
        }
      }
      setLoading(false);
    };
    getLanguage();
  }, [id, form]);

  const onFinish = async (values) => {
    setLoading(true);
    const languInfo = new FormData();

    if (images[0]?.file) {
      languInfo.append("image", images[0]?.file);
    }

    languInfo.append("id", id);
    languInfo.append("language_short_name", values.language_short_name);
    languInfo.append("language_full_name", values.language_full_name);

    const res = await fetch(`${process.env.REACT_APP_APIURL}/admin/updatelanguage`, {
      method: "PATCH",
      body: languInfo,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });

    const response = await res.json();
    if (response?.status_code === 200) {
      toast.success(response.message);
      navigate("/admin/language/manage");
    } else {
      toast.error(response?.message || response?.err);
    }
    setLoading(false);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Helmet>
        <title>
          {t("Admin")} - {t("Edit_Language")}
        </title>
      </Helmet>
      <Title level={3} className="text-center">
        {t("Edit_Language")}
      </Title>

      <Card className="max-w-2xl mx-auto">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="space-y-6"
        >
          <Form.Item
            label={t("add_Language_srt")}
            name="language_short_name"
            rules={[{ required: true, message: t("Required") }]}
          >
            <Input placeholder={t("add_Language_srt")} />
          </Form.Item>

          <Form.Item label={t("Language_county_Image")}>
            <ImageUploading value={images} onChange={onChange} dataURLKey="data_url">
              {({ imageList, onImageUpload, onImageRemove }) => (
                <div>
                  <Button icon={<UploadOutlined />} onClick={onImageUpload}>
                    {t("add_new_product_T_img_info")}
                  </Button>
                  <div className="flex mt-4 gap-4 flex-wrap">
                    {imageList.map((image, index) => (
                      <div key={index} className="relative">
                        <img
                          src={image.data_url}
                          alt=""
                          className="w-20 h-20 object-cover border"
                        />
                        <Button
                          danger
                          size="small"
                          className="absolute top-0 right-0"
                          onClick={() => onImageRemove(index)}
                        >
                          X
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </ImageUploading>
          </Form.Item>

          <Form.Item
            label={t("Language_full_name")}
            name="language_full_name"
            rules={[{ required: true, message: t("Required") }]}
          >
            <Input placeholder={t("Language_full_name")} />
          </Form.Item>

          <Form.Item>
            <Space className="flex justify-center">
              <Link to="/admin/language/manage">
                <Button danger>{t("Cancel")}</Button>
              </Link>
              <button type="submit" className="btn btn-primary btn-sm text-white">
                {t("vd_pc_btn2")}
              </button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default EditLanguage;

